import { useLocation } from 'react-router-dom'

export type RouteKind = 'home' | 'delivery' | 'cart' | 'checkout'

export function useRouteKind(): RouteKind {
  const { pathname } = useLocation()
  const rest = pathname.split('/').filter(Boolean).slice(1)

  if (rest[0] === 'cart') return rest[1] === 'checkout' ? 'checkout' : 'cart'
  if (rest[0] === 'delivery-conditions') return 'delivery'
  return 'home'
}
